var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166931 7.16083V11.1261C0.166931 11.6714 0.613028 12.1175 1.15826 12.1175H4.13223L7.39369 15.3789C8.01823 16.0035 9.08886 15.5574 9.08886 14.6751V3.60198C9.08886 2.7197 8.01823 2.2736 7.39369 2.89814L4.13223 6.16951H1.15826C0.613028 6.16951 0.166931 6.61561 0.166931 7.16083ZM13.5498 9.14348C13.5498 7.38884 12.5387 5.88202 11.0715 5.14844V13.1286C12.5387 12.4049 13.5498 10.8981 13.5498 9.14348ZM11.0715 1.65898V1.85724C11.0715 2.23395 11.3193 2.56109 11.6663 2.69987C14.2239 3.72094 16.0281 6.22899 16.0281 9.14348C16.0281 12.058 14.2239 14.566 11.6663 15.5871C11.3094 15.7259 11.0715 16.053 11.0715 16.4297V16.628C11.0715 17.2525 11.696 17.6887 12.271 17.4706C15.6316 16.1918 18.0108 12.9502 18.0108 9.14348C18.0108 5.3368 15.6316 2.09516 12.271 0.816353C11.696 0.588348 11.0715 1.03444 11.0715 1.65898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerSound);
export default __webpack_public_path__ + "static/media/player-sound.9483b873205e4a39a69cacc397273b8c.svg";
export { ForwardRef as ReactComponent };